import $ from 'jquery'
import CryptoJS from 'crypto-js'
import InvalidSpSessionError from './invalid-sp-session-error.js'
import utils from '../utils/utils.js'
import SpLogoutError from './sp-logout-error.js'
import Promise from 'promise'
import SessionResponse from './session-response.js'
import SpAuthenticationFailedError from './sp-authentication-failed-error.js'

var serviceProvider = function(){}

function validateSamlResponse(samlResponse){
  if (samlResponse===undefined || samlResponse==='')
    throw new Error('no saml response given')

  if (samlResponse.sp===undefined)
    throw new Error('saml request has no service provider property')

  if (samlResponse.relayState===undefined)
    throw new Error('saml request has no relayState property')

  if (samlResponse.samlResponse===undefined)
    throw new Error('saml request has no samlResponse property')
}

function isErrorResponseValidSAMLRequest(error){
  return (error !== undefined && error.responseJSON !== undefined &&
  error.responseJSON.auth !== undefined && error.responseJSON.auth.form !== undefined &&
  error.responseJSON.nextState==='IDP_AUTH')
}

function isErrorResponseSAMLLogoutRequest(error){
  return (error !== undefined && error.responseJSON !== undefined &&
  error.responseJSON.form !== undefined)
}

function log(message){
  console.log('service-provider: ' + message)
}

serviceProvider.validateSession = function(url, relayState){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      if (url===undefined || url==='')
        throw new Error('no url given')

      log('sending verification to ' + url)
      $.ajax({
        url: url,
        xhrFields: { withCredentials: true },
        method: 'GET',
        contentType: 'application/json',
        data: {
          RelayState: relayState
        }
      }).done(({auth})=>{
        log('session successfully verified at ' + url)
        let jwt = utils.decodeBase64JwtToken(auth.jwt)
        promiseRes(jwt)
      }).error((httpError)=> {
        log(url + ' returned error ' + httpError.status)
        if (httpError.status===401) {
          if (isErrorResponseValidSAMLRequest(httpError)) {
            log('error contains valid saml request')
            promiseErr(new InvalidSpSessionError(httpError.responseJSON))
          }
          else {
            let message = url + ' did not return valid saml request with error'
            log(message)
            promiseErr(new Error(message))
          }
        }
        else if (httpError.status===422) {
          log('IP restricted error')
          promiseErr(new SpAuthenticationFailedError(httpError.responseJSON.message, httpError.responseJSON.nextState, httpError.responseJSON.auth))
        }
        else
          promiseErr(new Error('verify session returned server error ' + httpError.status))
      })
    } catch (err){
      if (err instanceof Error)
        throw err
      promiseErr(new Error('unable to perform verification due to ' + err))
    }
  })
}

serviceProvider.createSession = function(samlResponse){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      validateSamlResponse(samlResponse)

      let url = samlResponse.sp
      log('sending create session request to ' + url)
      $.ajax({
        url: url,
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        dataType: 'json',
        xhrFields: {withCredentials: true},
        data: {
          RelayState: samlResponse.relayState,
          SAMLResponse: samlResponse.samlResponse
        }
      }).done(({auth}, text, httpResponse)=> {
        log('returned status ' + httpResponse.status)
        log('valid session was created at sp ' + url)
        let jwt = utils.decodeBase64JwtToken(auth.jwt)
        let location = utils.extractLocation(httpResponse)
        promiseRes(new SessionResponse(location, jwt))
      }).error((httpError)=> {
        log('returned error ' + httpError.status)
        if (httpError.status === 401 || httpError.status === 422) {
          let message = 'not authenticated for channel at sp ' + url + ', please ensure you are assigned to the correct group'
          log(message)
          promiseErr(new SpAuthenticationFailedError(httpError.responseJSON.message, httpError.responseJSON.nextState, httpError.responseJSON.auth))
        } else {
          promiseErr(new Error('createsession returned server error ' + httpError.status))
        }
      })
    } catch (err) {
      if (err instanceof Error)
        throw err
      promiseErr(new Error('error requesting createSession at service provider due to ' + err))
    }
  })
}

serviceProvider.userInitiatedLogout = function(url){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      if (url===undefined || url==='')
        throw new Error('no url given')

      $.ajax({
        url: url,
        xhrFields: {withCredentials: true},
        method: 'POST',
        contentType: 'application/json'
      }).done(()=> {
        log('session is successfully logged out' + url)
        promiseRes()
      }).error((httpError)=> {
        log(url + ' returned error ' + httpError.status)
        if (httpError.status === 401) {

          if (isErrorResponseSAMLLogoutRequest(httpError)) {
            log('error contains valid saml request')
            promiseErr(new SpLogoutError(httpError.responseJSON))
          }
          else {
            let message = url + ' did not return valid saml logout request with error'
            log(message)
            promiseErr(new Error(message))
          }
        }
        else
          promiseErr(new Error('logout session returned server error ' + httpError.status))
      })
    } catch (err) {
      if (err instanceof Error)
        throw err
      promiseErr(new Error('unable to perform logout due to ' + err))
    }
  })
}

serviceProvider.destroySession = function(samlResponse){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      if (samlResponse === undefined)
        throw new Error('no saml response given')

      let url = samlResponse.sp
      $.ajax({
        url: url,
        xhrFields: {withCredentials: true},
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: {
          SAMLResponse: samlResponse.samlResponse
        }
      }).done(()=> {
        log(url + ' session was successfully destroyed ')
        promiseRes()
      }).error((httpError)=> {
        let message = url + ' unable to destroy session ' + httpError.status
        log(message)
        promiseErr(new Error(message))
      })
    } catch (err) {
      if (err instanceof Error)
        throw err
      promiseErr(new Error('unable to destroy session due to ' + err))
    }
  })
}

export default serviceProvider


/** WEBPACK FOOTER **
 ** ./components/service-provider/service-provider.js
 **/